import { toaster } from 'baseui/toast';
import { NOTIFICATION_TYPE } from '../../../common/constant/constant';
import type { ShowNotificationT } from '../../../common/types/types';
import { TOAST_AUTO_HIDE_MS } from '../constants/frame-timeline-v4';
export const showNotificationViaToaster: ShowNotificationT = (notificationType, message) => {
  switch (notificationType) {
    case NOTIFICATION_TYPE.ERROR:
      toaster.negative(message, {
        autoHideDuration: TOAST_AUTO_HIDE_MS
      });
      break;
    case NOTIFICATION_TYPE.WARNING:
      toaster.warning(message, {
        autoHideDuration: TOAST_AUTO_HIDE_MS
      });
      break;
    case NOTIFICATION_TYPE.SUCCESS:
      toaster.positive(message, {
        autoHideDuration: TOAST_AUTO_HIDE_MS
      });
      break;
    default:
      toaster.info(message, {
        autoHideDuration: TOAST_AUTO_HIDE_MS
      });
  }
};